
import { useDispatchStoreActionMixin } from '@teamnovu/utils'

export default {
  mixins: [
    useDispatchStoreActionMixin({
      action: 'user/sendResetLink',
    }),
  ],

  layout: 'guest',

  auth: 'guest',

  nuxtI18n: {
    paths: {
      de_CH: '/passwort-vergessen',
    },
  },

  data() {
    return {
      form: {
        email: '',
      },

      message: '',
    }
  },

  head() {
    return {
      title: this.$t('forgot-password.title'),
    }
  },

  methods: {
    async submit() {
      this.message = ''
      try {
        const { message } = await this.dispatchStoreAction(this.form)
        this.message = message
        this.$refs.observer.reset()
        this.form.email = ''
      } catch (error) {
        console.log({ error })
      }
    },
  },
}
